/**
 * Mobile Design Tokens - Flat Structure
 *
 * @deprecated For new code, import from './tokens' directly:
 *   import { colors } from '../styles/tokens'
 *
 * This file now references the centralized tokens in tokens.js.
 * Existing mobile components can continue using MobileColors without changes.
 */

import { colors } from './tokens'

export const MobileColors = {
  // Brand colors
  primary: colors['brand'], // fb-green-900 / new-company-green-dark
  primaryDark: '#00361d', // fb-green-950 (darkest) — not in semantic tokens
  primaryActive: colors['brand-active'], // new-company-green-active (FB Green 3)
  accent: colors['brand-hover'], // fb-dark-green (medium green)

  // Backgrounds
  backgroundPage: colors['surface'],
  backgroundCard: colors['surface-muted'], // sage-50 (Extra LT Sage) - result cards default
  backgroundCardHover: colors['surface-hover'], // pistachio-200 (Pistachio 4) - result cards hover
  backgroundCardActive: colors['surface-active'], // new-company-pistachio-medium (Pistachio 2) - pressed state
  backgroundFilterTag: colors['surface-hover'], // pistachio-200 - applied filter tags
  backgroundFilterTagHover: '#C5DED3', // pistachio-100 — not in semantic tokens
  backgroundBadge: colors['surface-disabled'], // new-company-gray-border - category badges
  backgroundOverlay: colors['surface-sunken'], // gray-50 - overlays, panels

  // Text colors
  textPrimary: colors['fg'], // new-company-gray-900 - primary text
  textSecondary: colors['fg-secondary'], // new-company-gray-500 - secondary text, labels
  textMuted: colors['fg-muted'], // new-company-gray-inactive - placeholder, disabled
  textLink: colors['brand'], // fb-green-900 - links, interactive text
  textLinkHover: colors['brand-active'], // new-company-green-active - link hover

  // Border colors
  borderDefault: colors['line'], // new-company-gray-border - input borders, dividers
  borderFocus: colors['brand'], // fb-green-900 - input focus state

  // Icon colors
  iconPrimary: colors['fg-secondary'], // new-company-gray-500 - search icon, location pin
  iconSecondary: colors['fg-muted'], // new-company-gray-inactive - inactive icons

  // Shadow colors (with opacity)
  shadowSm: 'rgba(0, 0, 0, 0.1)', // Small shadows on cards
  shadowBrand: 'rgba(6, 81, 47, 0.1)', // fb-green-900 with opacity

  // Overlay colors
  overlay: colors['modal-overlay'], // #041E12 at 50% opacity - dark green overlay for modals

  // Backwards compatibility aliases (deprecated - use semantic names above)
  backgroundWhite: colors['surface'], // @deprecated Use backgroundPage instead
  backgroundSelected: '#E5ECE7', // @deprecated Use backgroundFilterTag or backgroundCardHover
  backgroundHover: colors['surface-hover'], // @deprecated Use backgroundCardHover instead
  backgroundActive: colors['surface-active'], // @deprecated Use backgroundCardActive instead
  backgroundLight: '#f3f4f6', // @deprecated Use backgroundOverlay instead
  badgeBackground: colors['surface-disabled'], // @deprecated Use backgroundBadge instead
  borderMedium: colors['line'], // @deprecated Use borderDefault instead
} as const

// Bottom clearance so a mobile scroll area's last item clears the fixed footer:
// 60px footer height (see Footer.styles.tsx MobileContent) + safe-area + buffer.
export const MOBILE_FOOTER_CLEARANCE =
  'calc(60px + env(safe-area-inset-bottom, 0px) + 16px)'
